import { createContext, useContext } from 'react';

import type { ProductCurrencyType } from '@/entities/product/types';

const CurrencyContext = createContext<ProductCurrencyType>('KRW');

export function CurrencyProvider({
  value,
  children,
}: {
  value: ProductCurrencyType;
  children: React.ReactNode;
}) {
  return <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>;
}

export function useCurrency() {
  const v = useContext(CurrencyContext);
  if (!v) throw new Error('CurrencyContext is missing');
  return v;
}
